import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';

import { HisSharedModule } from 'hisng';

import { CommonSharedModule } from 'app/fs/res/common/common-shared.module';

import { PrizeSearchFormComponent } from './component/prize-search-form.component';
import { PrizeSearchResultComponent } from './component/prize-search-result.component';
import { PrizeEditFormComponent } from './component/prize-edit-form.component';
import { PrizeEditBasicDataTabComponent } from './component/edit/prize-edit-basic-data-tab.component';
import { PrizeEditBasicDataComponent } from './component/edit/basic-data/prize-edit-basic-data.component';
import { PrizeEditAwardingOrganizationComponent } from './component/edit/awarding-organization/prize-edit-awarding-organization.component';

/**
 * SharedModule for prizes.
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,

        // primeng
        AutoCompleteModule,
        ConfirmDialogModule,
        InputTextModule,
        PanelModule,
        TableModule,
        TabViewModule,

        // HIS
        HisSharedModule,
        CommonSharedModule,
    ],

    declarations: [
        PrizeSearchFormComponent,
        PrizeSearchResultComponent,
        PrizeEditBasicDataTabComponent,
        PrizeEditFormComponent,
        PrizeEditBasicDataComponent,
        PrizeEditAwardingOrganizationComponent
    ],

    exports: [
    ]
})
export class PrizeSharedModule {
}
